import axios from 'axios';
import { object2GetParams } from '@/helpers/url';

const uri = '/objects';

const state = {
  entries: [],
  meta: {},
  fields: [
    {
      name: 'type',
      label: 'Type',
      type: 'ref',
    },
  ],
};

// getters
const getters = {
  getFields(state) {
    return state.fields;
  },
  getMeta(state) {
    return state.meta;
  },
  get(state) {
    return state.entries;
  },
};

// actions
const actions = {
  async add({ commit }, { object, callback }) {
    const { data } = await axios.post(`${uri}`, object);
    commit('add', data);

    if (typeof callback === 'function') {
      callback(data);
    }
  },
  async get({ commit }, input) {
    let query = '';
    if (input && input.params) {
      query = `?${object2GetParams(input.params)}`;
    }
    const { data } = await axios.get(`${uri}${query}`);
    if (data && data.items && data.meta) {
      // commit('get', data.items);
      // commit('setMeta', data.meta);
      commit('append', data);
    } else if (data) {
      commit('get', data);
    }

    if (typeof input !== 'undefined' && typeof input.callback === 'function') {
      input.callback(data);
    }
  },
  async update({ commit }, { object, callback }) {
    const { data } = await axios.put(`${uri}`, object);
    commit('set', data);

    if (typeof callback === 'function') {
      callback(data);
    }
  },
  async delete({ commit }, { id, callback }) {
    await axios.delete(`${uri}`, {
      params: {
        id,
      },
    });
    commit('delete', id);

    if (typeof callback === 'function') {
      callback();
    }
  },
  async deploy({ commit }, { website, server, callback }) {
    const { data } = await axios.post(`/deploy`, {
      website,
      server,
    });
    commit('deploy', website);

    if (typeof callback === 'function') {
      callback(data);
    }
  },
  async deleteWebsite({ commit }, { website, server, callback }) {
    const { data } = await axios.post(`/deleteWebsite`, {
      website,
      server,
    });
    commit('deleteWebsite', website);

    if (typeof callback === 'function') {
      callback(data);
    }
  },
  async ssl({ commit }, { domain, server, callback }) {
    const { data } = await axios.post(`/ssl`, {
      domain,
      server,
    });
    commit('ssl', {
      domain,
    });

    if (typeof callback === 'function') {
      callback(data);
    }
  },
  async domainconfig({ commit }, { domain, dev_domain, server, callback }) {
    const { data } = await axios.post(`/domainconfig`, {
      domain,
      dev_domain,
      server,
    });
    commit('domainconfig', {
      domain,
      dev_domain,
    });

    if (typeof callback === 'function') {
      callback(data);
    }
  },
};

function prepareDataForEntries(data) {
  const prepared = [];
  data.forEach(element => {
    const edited = {};
    if (element.body) {
      Object.keys(element.body).forEach(key => {
        edited[key] = element.body[key];
      });
    }
    if (element._id) {
      edited._id = element._id;
    }
    prepared.push(edited);
  });
  return prepared;
}

// mutations
const mutations = {
  add(state, entry) {
    state.entries.push(entry);
  },
  get(state, data) {
    const prepared = prepareDataForEntries(data);
    state.entries = prepared;
  },
  append(state, data) {
    const prepared = prepareDataForEntries(data.items);

    if (state.meta.object_type === data.meta.object_type) {
      prepared.forEach(item => {
        const found = state.entries.find(element => {
          return element._id === item._id;
        });
        if (!found) {
          state.entries.push(item);
        }
      });
    } else {
      state.entries = prepared;
    }
    state.meta = data.meta;
  },
  set(state, data) {
    state.entries.forEach(element => {
      if (element._id === data._id) {
        element = data;
      }
    });
  },
  delete(state, id) {
    state.entries = state.entries.filter(element => element._id !== id);
  },
  setMeta(state, data) {
    state.meta = data;
  },
  /* eslint-disable */
  deploy(state, website) {

  },
  ssl(state, {
    domain
  }) {

  },
  domainconfig(state, {
    domain,
    dev_domain
  }) {

  }
  /* eslint-enable */
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
